// src/components/UI/GlassCard.js
import React from 'react';

const GlassCard = ({ children, className = '', padding = '25px', hover = true }) => {
  return (
    <div 
      className={`glass rounded-[24px] ${hover ? 'hover:bg-white/[0.08] hover:border-white/20 transition-all duration-300' : ''} ${className}`}
      style={{ padding }}
    >
      {children}
    </div>
  );
};

export default GlassCard;
